import { Box, IconButton, Menu, MenuButton, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { formatDateAnnouncements, setEdit } from "../../redux/actions/actions";
import { ReactComponent as ContextMenuIcon } from '../../svg/ContextMenu.svg'

export default function IndividualAnnouncementCard({ title, startingDate, endingDate, startingTime, endingTime, department, id, removeAnnouncement }) {
    const dispatch = useDispatch()
    const history = useHistory()

    const editHandler = () => {
        dispatch(setEdit(id))
        history.push('/add-announcements')
    }

    return (
        <Box
            d='flex'
            width='100%'
            bg='white'
            borderRadius='2xl'
            my='1rem'
            justifyContent='center'
            alignItems='flex-start'
            flexDirection='column'
            style ={{gap: '2rem'}}
            _hover={{ boxShadow: 'xl' }}
            px={['1rem', '1rem', '2rem']}
            py={['1.5rem', '1.5rem', '2rem']}
        >
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='flex-start'
                width='100%'
                mb='1rem'
            >
                <Box
                    d='flex'
                    flexDir='column'
                    alignItems='flex-start'
                    justifyContent='center'
                >
                    <Text
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize='15px'
                        color='#798599'
                    >
                        Announcement
                    </Text>

                    <Text
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize='18px'
                        color='#333333'
                    >
                        {title}
                    </Text>
                </Box>

                <Menu>
                    <MenuButton
                        as={IconButton}
                        // mr='1rem'
                        border='2px solid rgba(0, 0, 0, 0.1)'
                        icon={<ContextMenuIcon />}
                        bg='white'
                        _hover={{ bg: "#f8f8f8" }}
                        _active={{ bg: "#f8f8f8" }}
                        size={['xs', 'sm', 'sm', 'lg']}
                        px='2'
                        py='1'
                    />
                    <MenuList style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize='15px' color='#00000099' minW='0' w='150px' position='relative' zIndex='10' >
                        <MenuItem onClick={editHandler}>Edit</MenuItem>
                        <MenuItem onClick={() => removeAnnouncement(id)}>Delete</MenuItem>
                    </MenuList>
                </Menu>
            </Box>
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='flex-start'
                width='100%'
            >

                <Box
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='flex-start'
                    width={['40%', '40%', '50%']}
                    flexDirection='column'
                >
                    <Text
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize={['12px', '14px', '15px']}
                        color='#798599'
                    >
                        Start Date
                    </Text>

                    <Box
                        d='flex'
                    >
                        <Text style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['16px', '16px', '18px', '18px']} color='#000000' >{startingDate ? `${formatDateAnnouncements(startingDate)} at ${startingTime}` : 'N/A'}</Text>
                    </Box>
                </Box>

                <Box
                    d='flex'
                    flexDir='column'
                    alignItems='flex-end'
                    justifyContent='center'
                    width={['60%', '60%', '50%']}
                >
                    <Text
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize={['12px', '14px', '15px']}
                        color='#798599'
                    >
                        Department
                    </Text>
                    <Box
                        d='flex'
                    >
                        <Text style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['16px', '16px', '18px', '18px']} color='#000000' >{department ? department : 'N/A'}</Text>
                    </Box>

                </Box>
            </Box>

            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='center'
                width='100%'
            >
                <Box
                    d='flex'
                    flexDir='column'
                    alignItems='flex-start'
                    justifyContent='center'
                    width={['60%', '60%', '50%']}
                >
                    <Text
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize={['12px', '14px', '15px']}
                        color='#798599'
                    >
                        End Date
                    </Text>
                    <Box
                        d='flex'
                        width = '100%'
                    >
                        <Text style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['16px', '16px', '18px', '18px']} color='#000000' >{endingDate ? `${formatDateAnnouncements(endingDate)} at ${endingTime}` : 'N/A'}</Text>
                    </Box>

                </Box>

            </Box>
        </Box >
    )
}